export const generalAllowedExtensions = [
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "webp",
  "doc",
  "docx",
];
export const imageAllowedExtensions = ["jpg", "jpeg", "png"];

export const residentProfileMimeTypes = [
  "image/jpg",
  "image/jpeg",
  "image/png",
];
